<div id="attribute">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="padding-10 color-gray font-white-color fixed-header">
    <span class="popup-title">{{enableSalesAssistant == 1 ? 'Email Composer & AI Sales Assistant' : 'Email
      Composer'}}</span>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">

      <button [attr.guide]="'email-popup-component-btn-1' + '__' + sanitizedUrl" [disabled]="text !== 'Send'"
        (click)="sendEmail()" mat-raised-button>
        {{text}}
        <mat-icon *ngIf="text !== 'Send'">
          <mat-spinner color="primary" diameter="20">
          </mat-spinner>
        </mat-icon>
      </button>

      <div fxFlex="25">

      </div>

      <button [attr.guide]="'email-popup-component-btn-2' + '__' + sanitizedUrl" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="new-scroll-type email-popup-split-container" #pageContainer>

    <!-- Left Column: Composer Form -->
    <div class="composer-form-column">
      <perfect-scrollbar style="width: 100%;overflow: visible;" class="scroll">
        <div>
          <mat-card class="mat-elevation-z4 email-card">

            <mat-card-content [formGroup]="firstFormGroup">
              <div fxLayout="column">

                <div *ngIf="useIndividualMail == 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px"
                  class="email-input-section">

                  <mat-form-field appearance="outline"
                    [fxFlex]="firstFormGroup.controls.fromEmailId.errors?.required && useIndividualMail == 1? 90 : 100">
                    <mat-label>From</mat-label>
                    <mat-select formControlName="fromEmailId" [disableOptionCentering]="true" #singleSelect
                      autocomplete="off" (selectionChange)="onFromEmailChange($event.value)">
                      <mat-option>
                        <ngx-mat-select-search name="Email Search" ngDefaultControl [formControl]="typeYFilterControl"
                          placeholderLabel="From Email Search" [preventHomeEndKeyPropagation]="true"
                          noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                        [value]="opt.userMailConfigId">
                        {{ opt.emailAddress }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="firstFormGroup.controls.fromEmailId.errors?.required && useIndividualMail != 1">
                      Please fill out this field.
                    </mat-error>

                    <mat-error *ngIf="firstFormGroup.controls.fromEmailId.errors?.required && useIndividualMail == 1">
                      Please configure mail id to send the email.
                    </mat-error>


                  </mat-form-field>

                  <button *ngIf="firstFormGroup.controls.fromEmailId.errors?.required && useIndividualMail == 1"
                    mat-raised-button color="primary" (click)="goToMailConfig()">
                    Configure Mail
                  </button>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" class="email-input-section">
                  <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                    <mat-label>Email Address</mat-label>
                    <input [attr.guide]="'email-popup-component-inp-email' + '__' + sanitizedUrl" required matInput
                      formControlName="email" placeholder="Enter valid email address" trim="blur" />
                    <mat-error *ngIf="firstFormGroup.controls.email.errors?.required">
                      Please fill out this field.

                    </mat-error>
                    <!-- <mat-icon matSuffix class="input-icon">alternate_email</mat-icon> -->
                  </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" class="email-input-section">
                  <mat-form-field appearance="outline" floatLabel="always" class="subject-field">
                    <mat-label>Cc</mat-label>
                    <mat-chip-list #chipList aria-label="CC Email List">
                      <mat-chip *ngFor="let email of ccEmails" [removable]="true" (removed)="removeCcEmail(email)">
                        {{ email }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input [attr.guide]="'email-popup-component-inp-3' + '__' + sanitizedUrl" placeholder="Add email"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addCcEmail($event)" />
                    </mat-chip-list>

                  </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" class="email-input-section">
                  <mat-form-field appearance="outline" floatLabel="always" class="subject-field">
                    <mat-label>Bcc</mat-label>
                    <mat-chip-list #bccChipList aria-label="BCC Email List">
                      <mat-chip *ngFor="let email of bccEmails" [removable]="true" (removed)="removeBccEmail(email)">
                        {{ email }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input [attr.guide]="'email-popup-component-inp-4' + '__' + sanitizedUrl" placeholder="Add email"
                        [matChipInputFor]="bccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addBccEmail($event)" />
                    </mat-chip-list>
                    <!-- Hidden input to store comma-separated emails in the form -->
                    <input [attr.guide]="'email-popup-component-inp-bcc' + '__' + sanitizedUrl" type="hidden"
                      formControlName="bcc" />
                  </mat-form-field>

                </div>
                <div fxLayout="row" fxLayoutAlign="start center" class="email-input-section">
                  <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                    <mat-label>Subject</mat-label>
                    <input [attr.guide]="'email-popup-component-inp-subject' + '__' + sanitizedUrl" required matInput
                      formControlName="subject" trim="blur" />
                    <mat-error *ngIf="firstFormGroup.controls.subject.errors?.required">
                      Please fill out this field.
                    </mat-error>
                  </mat-form-field>

                </div>

                <div *ngIf="type == 1" fxLayout="row" fxLayoutAlign="start center" class="email-input-section">

                  <mat-form-field fxFlex="45" appearance="outline">
                    <mat-label>Use Template</mat-label>
                    <mat-select formControlName="template" [disableOptionCentering]="true" #singleSelect>
                      <mat-option>
                        <ngx-mat-select-search name="Template Search" ngDefaultControl
                          [formControl]="templateFilterControl" placeholderLabel="Template Search"
                          [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option (onSelectionChange)="onTemplateSelect($event, opt)"
                        *ngFor="let opt of filteredTemplateList; let i=index;" [value]="opt.templateName">
                        {{opt.templateName}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>

                  <div fxFlex="3">

                  </div>

                  <mat-form-field fxFlex="45" appearance="outline">
                    <mat-label>Insert Fields</mat-label>


                    <mat-select formControlName="fieldControl" (selectionChange)="insertField($event, $event.value)">
                      <mat-option *ngFor="let opt of insert" [value]="opt">
                        {{opt.viewValue}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>

                </div>


                <div class="products-padding">

                  <!-- calsoft-doc-editor is now a ControlValueAccessor, so formControlName="body" works and patchValue/setValue will update the editor -->
                  <calsoft-doc-editor #composeEditor formControlName="body" [mode]="'compose'"
                    [externalInsertText]="composeEditorInsertText" [externalInsertToken]="composeEditorInsertToken">
                  </calsoft-doc-editor>



                </div>

                <div class="imageattachment gmail-style-attachments">

                  <div class="attachments-header">
                    <div class="title-head3" color="primary"><span>Attachments</span></div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="start start" class="attachments-bar"
                    formArrayName="attachments">
                    <div fxLayout="row" class="attachment-chip"
                      *ngFor="let attachment of firstFormGroup.get('attachments')['controls']; let k = index"
                      [formGroupName]="k">
                      <div class="thumb">
                        <ng-container
                          *ngIf="attachment.get('fileType').value != 'pdf' && attachment.get('fileType').value != 'docx' && attachment.get('fileType').value != 'xlsx'">
                          <calsoft-common-images [src]="serverPath + attachment.controls['image'].value"
                            [height]="'40px'" [width]="'40px'" [alt]=""></calsoft-common-images>
                        </ng-container>
                        <ng-container *ngIf="attachment.get('fileType').value == 'pdf'">
                          <img src="assets/images/pdf.png" height="40" width="40" alt="PDF File">
                        </ng-container>
                        <ng-container *ngIf="attachment.get('fileType').value == 'docx'">
                          <img src="assets/images/docx.png" height="40" width="40" alt="DOCX File">
                        </ng-container>
                        <ng-container *ngIf="attachment.get('fileType').value == 'xlsx'">
                          <img src="assets/images/excel.png" height="40" width="40" alt="XLSX File">
                        </ng-container>
                      </div>

                      <div class="name">{{ attachment.controls['image'].value }}</div>

                      <div class="action">
                        <button [attr.guide]="'email-popup-component-btn-5' + '__' + sanitizedUrl" mat-icon-button
                          color="warn" type="button" (click)="removeImageOption(k)">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>

                    <div class="attach-picker">
                      <calsoft-common-file-upload (fileUploadResult)="getResultBanner($event)"
                        [type]="'gmail'"></calsoft-common-file-upload>
                    </div>
                  </div>

                </div>


              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </perfect-scrollbar>
    </div>

    <!-- Right Column: AI Assistant Panel -->
    <div *ngIf="enableSalesAssistant == 1" class="ai-assistant-column">
      <div class="ai-assistant-card">

        <!-- Header -->
        <div class="ai-header">
          <div class="ai-title-row">
            <mat-icon class="ai-spark-icon animate-pulse">auto_awesome</mat-icon>
            <span class="ai-header-title">AI Sales Assistant</span>
          </div>
          <span class="ai-badge-glowing">CONNECTED TO CRM</span>
        </div>

        <!-- Strategy Context -->
        <div class="ai-strategy-context-box" *ngIf="strategicContext">
          <div class="context-label-row">
            <mat-icon class="context-icon">insights</mat-icon>
            <span>Strategic CRM Insights & Signals</span>
          </div>
          <pre class="context-pre">{{ strategicContext }}</pre>
        </div>

        <!-- Outreach Intent Tabs -->
        <div class="ai-tabs-container">
          <div class="ai-tab-title">Select Outreach Category</div>
          <div class="ai-tabs-grid">
            <button type="button" class="ai-tab-btn" [class.active]="selectedEmailType === 'followup'"
              (click)="selectEmailType('followup')">
              <mat-icon class="tab-icon">history</mat-icon> Follow-Up
            </button>
            <button type="button" class="ai-tab-btn" [class.active]="selectedEmailType === 'proposal'"
              (click)="selectEmailType('proposal')">
              <mat-icon class="tab-icon">description</mat-icon> Proposal
            </button>
            <button type="button" class="ai-tab-btn" [class.active]="selectedEmailType === 'stalled'"
              (click)="selectEmailType('stalled')">
              <mat-icon class="tab-icon">hourglass_empty</mat-icon> Stalled Deal
            </button>
            <button type="button" class="ai-tab-btn" [class.active]="selectedEmailType === 'nurture'"
              (click)="selectEmailType('nurture')">
              <mat-icon class="tab-icon">spa</mat-icon> Nurture Lead
            </button>
            <button type="button" class="ai-tab-btn" [class.active]="selectedEmailType === 'renewal'"
              (click)="selectEmailType('renewal')">
              <mat-icon class="tab-icon">autorenew</mat-icon> Renewal
            </button>
          </div>
        </div>

        <!-- Custom Instructions Input -->
        <div class="ai-input-box">
          <mat-form-field appearance="outline" class="subject-field">
            <mat-label>Custom AI Instructions (Optional)</mat-label>
            <input matInput [(ngModel)]="customInstructions"
              placeholder="e.g. 'offer 15% discount', 'make it concise', 'suggest Tuesday'"
              (keyup.enter)="generateDraft()" />
            <mat-hint>Press Enter or click below to refine your draft</mat-hint>
          </mat-form-field>
          <button type="button" mat-flat-button color="primary" class="ai-generate-btn" (click)="generateDraft()"
            [disabled]="aiLoading">
            <mat-icon class="spinning" *ngIf="aiLoading">sync</mat-icon>
            <mat-icon *ngIf="!aiLoading">bolt</mat-icon>
            {{ aiLoading ? 'Analyzing Context...' : 'Generate Context Draft' }}
          </button>
        </div>

        <!-- AI Draft Preview -->
        <div class="ai-draft-preview-box" *ngIf="aiSuggestedSubject">
          <div class="preview-header">
            <div class="preview-title-row">
              <mat-icon class="preview-icon">email</mat-icon>
              <span>AI Suggested Draft</span>
            </div>

            <div class="external-client-shortcuts">
              <a [href]="getMailtoUrl('gmail')" target="_blank" mat-icon-button matTooltip="Compose in Gmail"
                class="shortcut-btn gmail-btn">
                <mat-icon>mail_outline</mat-icon>
              </a>
              <a [href]="getMailtoUrl('outlook')" target="_blank" mat-icon-button matTooltip="Compose in Outlook"
                class="shortcut-btn outlook-btn">
                <mat-icon>business</mat-icon>
              </a>
            </div>
          </div>

          <div class="preview-subject-line">
            <strong>Subject:</strong> {{ aiSuggestedSubject }}
          </div>

          <div class="preview-body-content" [innerHTML]="aiSuggestedBody"></div>

          <!-- Actions -->
          <div class="preview-actions-row">
            <button type="button" mat-flat-button color="accent" class="action-btn apply-btn"
              (click)="applyDraftToForm()">
              <mat-icon>assignment_returned</mat-icon> Apply to Composer
            </button>
            <button type="button" mat-stroked-button class="action-btn copy-btn" (click)="copyDraftToClipboard()">
              <mat-icon>content_copy</mat-icon> Copy to Clipboard
            </button>
          </div>
        </div>

      </div>
    </div>

  </div>

  <div fxLayout="row" *ngIf="isShowScrollTop" fxLayoutAlign="center center" class="tap-top top-cls primary"
    (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </div>


</div>